export default "__VITE_PUBLIC_ASSET__b6c5b24b__"